module.exports = __webpack_public_path__ + "static/media/state.ca82393e.png";